import { IonIcon } from '@ionic/react';
import { chevronDownOutline, chevronUpOutline } from 'ionicons/icons';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { isMobileDevice } from '../../config/utils/deviceUtils';
import { hasCompanyProviderEnabled } from '../../store/companies/companiesSlice';
import { useAppSelector } from '../../store/hooks';

export const ProviderTransitObligationBanner = () => {
  const { t } = useTranslation();
  const hasProviderEnabled = useAppSelector(hasCompanyProviderEnabled);
  const isMobile = useMemo(() => isMobileDevice(), []);
  const [isCollapsed, setIsCollapsed] = useState(false);

  const message = t(
    hasProviderEnabled ? 'TRANSIT_OBLIGATION.TRANSIT_REQUIRED' : 'TRANSIT_OBLIGATION.TRANSIT_AND_PROVIDER_REQUIRED',
  );

  return (
    <div
      className="upgrade-required-banner page-layout-1200 p-t-16 p-b-0"
      {...(isMobile ? { onClick: () => setIsCollapsed((prev) => !prev), role: 'button' } : {})}
    >
      <p className={`upgrade-required-banner__text ${isMobile ? 'upgrade-required-banner__text--tappable' : ''}`}>
        {isMobile && isCollapsed ? t('TRANSIT_OBLIGATION.IMPORTANT_NOTICE') : message}
        {isMobile && (
          <IonIcon
            icon={isCollapsed ? chevronDownOutline : chevronUpOutline}
            className="upgrade-required-banner__chevron"
          />
        )}
      </p>
    </div>
  );
};
